/* V5.3 (speed): rewritten in vanilla JS — this was the only jQuery usage in the
   whole theme, so jQuery (~85KB) is no longer loaded at all. Same behavior:
   updates the "What's Included" size label when a size radio is picked. */
document.addEventListener('change', function (e) {
  var input = e.target;
  if (!input.matches('.product__info-container .product-form__input input[type="radio"]')) return;
  document.querySelectorAll('.new-included-selected-size').forEach(function (el) {
    el.textContent = input.value;
  });
});
